module.exports = __webpack_public_path__ + "static/img/br_head.c1a1d95e.webp";